"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.bulk.exceeded': 'Cannot upload {itemsToAdd} files. You have {remainingSlots} slots remaining out of {limit} maximum entries allowed.',
};
